import { a as createCommonjsModule } from '../common/_commonjsHelpers-fdecda49.js';
import { r as reactDom } from '../common/index-13c21b74.js';
import '../common/index-59f32655.js';

var client = createCommonjsModule(function (module, exports) {


{
  exports.createRoot = reactDom.createRoot;
  exports.hydrateRoot = reactDom.hydrateRoot;
}
});

export default client;
